import Entity from '../Entity';

export default class ManualCategory implements Entity {
  constructor(public id: number, public name: string) {}
}
